import { useCompaniesListTable } from "Company/Components/Tables/Hooks/useCompaniesListTable";
import { CompanyPaths } from "Company/Routes/Routing";
import { UserPermissions } from "Infrastructure/Api/permissions";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { hasPermission } from "Infrastructure/Utilities/Permissions/hasPermission";
import { PageContainer } from "Shared/Components/Container";
import { Table } from "Shared/Components/Table";
import { AddBusiness } from "@mui/icons-material";
import { Box, Button, Stack, Typography } from "@mui/material";
import type { FC } from "react";
import { useNavigate } from "react-router-dom";

const companyResource = Resources.base.company.shared;

export const CompanyPage: FC = () => {
	const { t } = useResource();
	const navigate = useNavigate();
	const tableOptions = useCompaniesListTable();

	const hasCreatePermission = hasPermission(
		UserPermissions.CompanyModule.create,
	);

	const handleNavigateToCreate = () => {
		navigate(CompanyPaths.Create.route);
	};

	return (
		<PageContainer
			title={t(companyResource.heading)}
			description="List of companies"
		>
			<Stack
				flexDirection="row"
				alignItems="center"
				justifyContent="space-between"
			>
				<Typography variant="h2" mb={2}>
					{t(companyResource.heading)}
				</Typography>
				{hasCreatePermission && (
					<Button
						startIcon={<AddBusiness fontSize="small" />}
						variant="contained"
						color="primary"
						onClick={handleNavigateToCreate}
					>
						{t(companyResource.addNewCompany)}
					</Button>
				)}
			</Stack>
			<Box mt={2}>
				<Table tableOptions={tableOptions} />
			</Box>
		</PageContainer>
	);
};
